import {Admin} from '../../_models/Admin'
import { toast } from 'react-toastify';

  export function updateAdmin(this:any, event:any) {
    event.preventDefault()
    let formData = new FormData();
    this.setState({updating: true})
    for (let key in this.state.admin) {
      if (this.state.admin[key] !== null) {
        let value = this.state.admin[key]
        if(typeof(value) == 'object' && value.length > 0) {
          value = JSON.stringify(value)
        }
        formData.append(key, value);
      }
    }

    if (this.picture.files.length > 0) {
      formData.set("picture", this.picture.files[0]);
    }


    formData.append("accountType", window.account.type || "")
    formData.append("accountId", window.account.id || "")

    //return
    fetch('admins/edit', {
      method: 'POST',
      body: formData,
      headers: {
          "Content-Type": "multipart/form-data",
      },
    }).then(results => {
      return results.json();
    }).then(data => {
        let admin = new Admin(data.admin)
        admin.updated = true
        if(!this.state.admin.id) {
          //New admin, go back
          window.location.href="/admins"
        } else {
          //It's an update
          this.setState({admin, updating: false})
        }
    }).catch(err => {
      alert(err.message);
      this.setState({updating: false})
    })


  }

  export function removeAdmin(this:any, id: number, index: number, event:any) {
    event.preventDefault()
    let confirmed = confirm("האם אתה בטוח?")
    if(!confirmed) return
    fetch('admins/delete', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(() => {
      let admins = this.state.admins
      admins.splice(index, 1)
      this.setState({admins})
    }).catch(err => {
      alert(err.message);
    })
  }


  export function handleSelectChange(this:any, selectedOption:any) {
    this.setState({ selectedOption }, () => {
      if(selectedOption.value) {
        let admin = this.state.admin
        admin.privilege = selectedOption.value
        admin.updated = false
        this.setState({admin})
      } else {
        let admin = this.state.admin
        admin.updated = false
        this.setState({admin})
      }
    });
  }


  export function resetPassword(this:any, id: number, event:any) {
    event.preventDefault()
    let confirmed = confirm("האם אתה בטוח?")
    if(!confirmed) return
    fetch('admins/resetPassword', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(() => {
      toast.success("הסיסמה נשלחה למשתמש")
    }).catch(err => {
      alert(err.message);
    })
  }


  export function handleAdminChange(this:any, event: any) {
    let admin = this.state.admin
    admin[event.target.name] = event.target.value
    admin.updated = false
    this.setState({admin});
  }



// WEBPACK FOOTER //
// ./src/pages/admin/controller.tsx